import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avance-vista" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "subtitulo" }
const _hoisted_4 = { class: "botones-header" }

import { useRoute } from 'vue-router'
import AvanceFactorPanel from '@/components/AvanceFactorPanel.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AvanceProcesoView',
  setup(__props) {

/**
 * Reporte de avance de un proceso (tablero F-04).
 *
 * Porcentaje de indicadores calificados y semáforo de evidencias por factor.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Reporte de avance del proceso", -1)),
        _createElementVNode("p", _hoisted_3, "Ejecución #" + _toDisplayString(_unref(idEjecucion)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
        }, "Volver"),
        _createElementVNode("button", {
          class: "btn dashboard",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Dashboard' })))
        }, "Ir al Dashboard")
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createVNode(AvanceFactorPanel, { "id-ejecucion": _unref(idEjecucion) }, null, 8, ["id-ejecucion"])
  ]))
}
}

})